import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { CompetitionsComponent } from './competitions.component';
import { CompetitionDetailsComponent } from './competiton-details/competition-details.component';

@NgModule({
  declarations: [CompetitionsComponent, CompetitionDetailsComponent],
  exports: [CompetitionsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    ToolbarModule,
    DataViewModule,
    ButtonModule,
    RippleModule,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    EditorModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    ChipModule,
    FileUploadModule,
    CardModule,
    ToastModule,
    ImageModule,
    InputGroupModule,
    FormsModule,
    ConfirmPopupModule,
    TableModule,
    InputTextareaModule,
    SelectButtonModule
  ],
  providers: [ConfirmationService]
})
export class CompetitionsModule {}
